module.exports = __webpack_public_path__ + "static/media/caro_img_1.933413b8.jpeg";